import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=3e3a3c7a&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
import style0 from "./Message.vue?vue&type=style&index=0&id=3e3a3c7a&prod&lang=scss&scoped=true"
import style1 from "./Message.vue?vue&type=style&index=1&id=3e3a3c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a3c7a",
  null
  
)

export default component.exports